import React from 'react';

// Barra min–mediana–max: rende visibile lo spread del dataset open, che a
// volte è deliberatamente ampio o asimmetrico (es. GHG lana da -26 a +37/kg
// per allocazione) e non va "pulito". Il pallino segna la mediana sul
// track [min, max]; i numeri restano nel testo accanto (questo è un rinforzo
// visivo, non l'unica fonte del dato). Solo classi Tailwind standard (CDN v2).
const RangeBar = ({ min, median, max }) => {
  const minNum = Number(min);
  const medianNum = Number(median);
  const maxNum = Number(max);
  if (!Number.isFinite(minNum) || !Number.isFinite(maxNum) || !Number.isFinite(medianNum) || maxNum === minNum) {
    return null;
  }
  const pct = Math.min(100, Math.max(0, ((medianNum - minNum) / (maxNum - minNum)) * 100));
  return (
    <div
      className="relative w-full max-w-[120px] h-1.5 my-1"
      title={`min ${min} · median ${median} · max ${max}`}
    >
      <div className="absolute inset-0 bg-gray-200 rounded-full" />
      <div
        className="absolute top-1/2 w-2 h-2 bg-emerald-500 rounded-full ring-2 ring-white"
        style={{ left: `${pct}%`, transform: 'translate(-50%, -50%)' }}
      />
    </div>
  );
};

export default RangeBar;
